module.exports = __webpack_public_path__ + "img/ics_o_booking.65004a45.svg";